import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";

export default function LastUpdated() {
  const [lastUpdated, setLastUpdated] = useState("");

  useEffect(() => {
    const modified = new Date(document.lastModified);
    setLastUpdated(modified.toLocaleDateString());
  }, []);

  return (
     <Typography variant="body2" color="white" align="right" >
         Last updated on: <strong>{lastUpdated}</strong>
       </Typography>
   
  );
}
